var _path, _path2, _polygon, _rect, _rect2, _path3, _rect3, _rect4, _path4, _path5, _path6, _path7, _path8, _path9, _polygon2, _circle, _path0, _path1, _polygon3, _polygon4, _polygon5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasinoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 62 62",
    xmlSpace: "preserve",
    viewBox: "2.53 2.3 56.95 57.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M53.551,30.564v10.304c0,1.292-1.049,2.34-2.34,2.34l0,0h-1.623v3.122h2.004c2.806,0,5.08-2.275,5.08-5.081  c0-0.001,0-0.001,0-0.001V29.38C55.447,28.773,54.435,29.32,53.551,30.564z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M47.921,30.63h-2.618l1.064,29.074h1.554c1.138,0,2.061-0.923,2.061-2.061V32.69  C49.981,31.553,49.059,30.63,47.921,30.63z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "24.447,13.561 2.526,14.466 2.526,46.33 24.447,46.916 46.367,46.33 46.367,14.466 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.526,
    y: 46.33,
    fill: "#FFFFFF",
    width: 43.841,
    height: 13.375
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.37,
    y: 21.286,
    width: 9.708,
    height: 15.888
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.877,26.805v2.425h1.9c-0.933,1.072-1.586,2.358-1.9,3.745h2.977c0.186-0.78,0.552-1.506,1.068-2.119  c0.422-0.497,0.653-1.129,0.651-1.781v-2.27H8.877z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.592,
    y: 21.286,
    width: 9.708,
    height: 15.888
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.814,
    y: 21.286,
    width: 9.709,
    height: 15.888
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.322,26.805v2.425h1.9c-0.934,1.072-1.586,2.358-1.9,3.744h2.975c0.187-0.78,0.553-1.505,1.068-2.118  c0.423-0.497,0.654-1.129,0.651-1.781v-2.27H35.322z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.099,26.805v2.425H24c-0.933,1.072-1.586,2.358-1.9,3.745h2.975c0.187-0.78,0.552-1.506,1.069-2.119  c0.422-0.497,0.653-1.129,0.651-1.781v-2.27H22.099z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.708,50.219h1.593c0.626,0,1.135,0.508,1.135,1.135v3.824c0,0.626-0.508,1.135-1.135,1.135H7.708  c-0.627,0-1.135-0.509-1.135-1.135v-3.824C6.573,50.727,7.081,50.219,7.708,50.219z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.707,50.219H16.3c0.626,0,1.135,0.508,1.135,1.135v3.824c0,0.626-0.508,1.135-1.135,1.135h-1.593  c-0.627,0-1.135-0.509-1.135-1.135v-3.824C13.572,50.727,14.08,50.219,14.707,50.219z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.716,50.219h1.593c0.627,0,1.135,0.508,1.135,1.135v3.824c0,0.626-0.508,1.135-1.135,1.135h-1.593  c-0.627,0-1.135-0.509-1.135-1.135v-3.824C20.581,50.727,21.089,50.219,21.716,50.219z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.423,51.719h10.459c0.592,0,1.072,0.48,1.072,1.072v0.799c0,0.592-0.48,1.072-1.072,1.072H30.423  c-0.592,0-1.073-0.48-1.073-1.072v-0.799C29.351,52.199,29.831,51.719,30.423,51.719z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "53.551,30.564 56.672,29.38 56.672,23.474 53.551,23.474 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 55.111,
    cy: 21.103,
    r: 4.362
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.25,8.784c-4.73-4.272-12.797-6.436-20.806-6.488c-0.816,4.016-0.816,8.155,0,12.17h21.923v-3.025  C46.386,10.438,45.98,9.474,45.25,8.784z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.444,2.298C16.233,2.243,8.08,4.404,3.642,8.784c-0.712,0.701-1.114,1.658-1.116,2.657v3.025h21.918  L24.444,2.298z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.447,10.553 22.296,11.683 22.707,9.289 20.967,7.593 23.372,7.244 24.447,5.065 25.521,7.244 27.926,7.593   26.186,9.289 26.597,11.683 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.053,10.754 36.82,11.683 36.482,9.716 37.912,8.323 35.937,8.036 35.053,6.246 34.17,8.036 32.194,8.323   33.623,9.716 33.286,11.683 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.485,10.754 15.253,11.684 14.915,9.716 16.345,8.322 14.369,8.035 13.485,6.246 12.603,8.035 10.627,8.322   12.056,9.716 11.719,11.684 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasinoIcon);
export default __webpack_public_path__ + "static/media/casino-icon.16c2778c466e15354178d92827c498c0.svg";
export { ForwardRef as ReactComponent };